import React from 'react';
import { colors, spacing, typography, typographyFlat } from '../../styles/tokens';

type ShowEmptyDaysToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

/** Reveals zero-activity periods in a pipeline trend table. Default is hidden. */
export const ShowEmptyDaysToggle: React.FC<ShowEmptyDaysToggleProps> = ({ checked, onChange }) => {
  return (
    <label style={styles.label}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      Show empty days
    </label>
  );
};

const styles: Record<string, React.CSSProperties> = {
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing.xs,
    color: colors.text,
    fontSize: typography.small.fontSize,
    fontWeight: typographyFlat.fontWeight.semibold,
    cursor: 'pointer',
  },
};
